export default __webpack_public_path__ + "static/media/arrows-diagonals.abeda630.svg";